__turbopack_context__.v({
  "cardList": "styles-module__KKoJYG__cardList",
  "cardList2Columns": "styles-module__KKoJYG__cardList2Columns",
  "cardList3Columns": "styles-module__KKoJYG__cardList3Columns",
});
